import React, { useState,useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import { makeGetRequest, makePostRequest } from "../utils/api";
import { urls } from "../utils/urls";
import { LinkContainer } from "react-router-bootstrap";
import { useDispatch } from "react-redux";
import { login, userAccessLevel } from "../store/slices/user";
import Container from "react-bootstrap/esm/Container";
import geriact_logo from "../media/images/geriact_logo2.png";
import { useNavigate } from "react-router-dom";

function Login() {
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState(false);
  const [userData, setUserData] = useState({
    username: "",
    password: "",
  });
  const [errorText, setErrorText] = useState("");
  const [logo, setLogo] = useState();
  const navigate = useNavigate();
  const handleUser = (e) => {
    setUserData((userData) => {
      return { ...userData, username: e.target.value.toLowerCase() };
    });
  };

  const handlePass = (e) => {
    setUserData((userData) => {
      return { ...userData, password: e.target.value };
    });
  };

  const handleLogin = async (data) => {
    data.preventDefault();
    setFormErrors(false);

    if (userData.password === "") {
      setErrorText(`Please enter a password.`);
      setFormErrors(true);
    }
    if (userData.username === "") {
      setErrorText(`Please enter an email.`);
      setFormErrors(true);
    }

    if (userData.username !== "" && userData.password !== "") {
      const response = await makePostRequest(urls.login, userData, {});
      if (response.status === 200) {
        dispatch(
          login({
            ...response.data,
          })
        );
        const userDetails = await makeGetRequest(urls.userDetails, "", true);
        if (userDetails.status === 200) {
          const data = { ...userDetails.data };
          dispatch(
            login({
              permissions: data[0].permissions,
              roles: data[0].roles,
              organizations: data[0].organizations,
              clientID: data[0].user_id,
              firstName: data[0].first_name.replaceAll(`"`, ""),
              lastName: data[0].last_name.replaceAll(`"`, ""),
              authenticated: true,
              ...response.data,
            })
          );
          navigate("/");
          window.location.reload();
        }
      }
      if (response.status === 401) {
        setFormErrors(true);
        setErrorText(response.data.detail);
        setUserData((prevData) => {
          return { ...prevData, password: "" };
        });
      }
    }
  };

  const UpdateLogo = async () => {
    const currentURL = window.location.href.split('//')
    let subdomain = currentURL[1].split('.')
    if(subdomain[0] != "geriactive"){
      const response = await makeGetRequest(
        urls.communityImage + "?community_subdomain=" + subdomain[0],
        ""
      );
      if(response.status == 200){
        if(response.data.length > 0){
          setLogo(response.data[0].community_image_url)
        }
      }
  }
}
  useEffect(() => {
    if(logo == undefined){
      UpdateLogo()
    }
  },[])

  return (
    <Container
      style={{
        display: "flex",
        alignItems: "center",
        textAlign: "left",
        minHeight: window.innerHeight - 40,
      }}
    >
      <Card
        style={{
          width: "500px",
          margin: "auto",
          padding: "25px",
          verticalAlign: "middle",
        }}
      >
        <Form onSubmit={handleLogin}>
          <div id="logoHandler" style={{ textAlign: "center" }}>
          {logo ? <><img src={logo} style={{ width: "450px", height: "150px" }} /></> : <><img src={geriact_logo} style={{ width: "400px", height: "300px" }} /></>}
          </div>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Email"
              onChange={handleUser}
            />
            <Form.Text className="text-muted"></Form.Text>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              onChange={handlePass}
            />
          </Form.Group>
          {formErrors ? (
            <Card style={{ marginBottom: "10px" }}>
              <Card.Body style={{ color: "red", fontSize: "12px" }}>
                {errorText}
              </Card.Body>
            </Card>
          ) : (
            ""
          )}
          <Form.Group className="mb-3" controlId="formBasicCheckbox">
            <Form.Check type="checkbox" label="Save username?" />
          </Form.Group>
          <Button variant="primary" type="submit">
            Submit
          </Button>
          <br />
          <br />
          {/**
          <div style={{ textAlign: "right" }}>
            <LinkContainer to="/forgot-your-password">
              <a>Forgot your password?</a>
            </LinkContainer>
          </div>
           */}
           Want to know more about GeriActive? <a href="https://news.geriactive.life" target="_blank" rel="noopener noreferrer">Click here</a> to visit our informational site.
        </Form>
      </Card>
    </Container>
  );
}


export default Login;
